import React from 'react'
import Typography from 'britive-design-system/core/components/typography'
import { translatedStrings } from '../constants'
import {
  convertTimeToCurrentTimezone,
  getSecretStatus,
  getApproversLabelText,
} from '../../utils'
import { classes } from '../request-modal/constants'
import StatusIcon from '../../../../components/statusIcon'

export const RequestDetails = ({ requestDetails }) => {
  const { managerApproval, consumer } = requestDetails
  const getApproversLabel = () => {
    return (
      <div>
        <Typography variant="label1">
          <i>{getApproversLabelText(managerApproval?.condition, consumer)}</i>
        </Typography>
      </div>
    )
  }
  const getApprovers = () => {
    const { approverStatuses, manager, managerApprovalStatus } = requestDetails
    const updatedApproverStatuses = approverStatuses?.filter(
      approver => approver?.userName !== manager
    )

    return (
      <div style={{ marginTop: '8px' }}>
        {manager && (
          <div className={classes.approverStatusContainer}>
            <Typography variant="label1">
              <span className={classes?.managerContainer}>
                {manager} <strong>(Manager)</strong>
              </span>
            </Typography>
            {managerApprovalStatus && (
              <div style={{ flexShrink: 0 }}>
                <StatusIcon status={managerApprovalStatus} />
              </div>
            )}
          </div>
        )}

        {updatedApproverStatuses
          ?.filter(approver => approver?.userName !== manager)
          ?.map((item, index) => (
            <div key={index} className={classes.approverStatusContainer}>
              <Typography variant="label1">
                <span className={classes?.managerContainer}>{item?.userName}</span>
              </Typography>
              {item?.status && (
                <div style={{ flexShrink: 0 }}>
                  <StatusIcon status={item?.status} />
                </div>
              )}
            </div>
          ))}
      </div>
    )
  }

  const containsTicketDetails =
    requestDetails?.context?.ticketNumber && requestDetails?.context?.ticketUrl
  return (
    <div className={classes.profileCheckoutRequestLayout}>
      <div className={classes.profileCheckoutRequestSpacing}>
        <div className={classes.profileCheckoutRequestSpacing}>
          <div className={classes.profileCheckoutRequestLabel}>
            <Typography variant="label2">{translatedStrings.requestOn}</Typography>
          </div>
          <div className={classes.profileCheckoutRequestValue}>
            <Typography variant="label1">
              {convertTimeToCurrentTimezone(requestDetails.createdAt)}
            </Typography>
          </div>
        </div>
      </div>

      <div className={classes.profileCheckoutRequestSpacing}>
        <div className={classes.profileCheckoutRequestLabel}>
          <div className={classes.approversLabelText}>
            <Typography variant="label2">{translatedStrings.approvers}</Typography>
            {managerApproval?.required &&
              managerApproval?.condition !== 'Manager' &&
              getApproversLabel()}
          </div>

          {getApprovers()}
        </div>
      </div>
      <div className={classes.profileCheckoutRequestSpacing}>
        <div className={classes.profileCheckoutRequestLabel}>
          <Typography variant="label2">{translatedStrings.status}</Typography>
        </div>
        <div className={classes.profileCheckoutRequestValue}>
          <Typography variant="label1">
            {getSecretStatus(requestDetails.status)}
          </Typography>
        </div>
      </div>
      <div className={classes.profileCheckoutRequestSpacing}>
        <div className={classes.profileCheckoutRequestLabel}>
          <Typography variant="label2">{translatedStrings.justification}</Typography>
        </div>
        <div className={classes.profileCheckoutRequestValue}>
          <Typography variant="label1">{requestDetails.justification}</Typography>
        </div>
      </div>

      {containsTicketDetails && (
        <div className={classes.profileCheckoutRequestSpacing}>
          <div className={classes.profileCheckoutRequestLabel}>
            <Typography variant="label2">
              {translatedStrings.ticketNumber}
            </Typography>
          </div>
          <div className={classes.profileCheckoutRequestValue}>
            <a
              href={requestDetails?.context?.ticketUrl}
              target="_blank"
              rel="noreferrer"
            >
              {requestDetails?.context?.ticketNumber}
            </a>
          </div>
        </div>
      )}
    </div>
  )
}
